import { useEffect, useState } from 'react';
import { formatarNumeroDecimal } from '../../../../utils/masks';

function createColaboradorDraft(pessoaId = null) {
    return {
        pessoaId: pessoaId || null,
        uuid: '',

        ativo: false,

        vendaInterna: false,
        vendaExterna: false,
        comissao: 0,
        comissaoInterna: 0,
        comissaoExterna: 0,

        dashboardFinanceiro: false,
        dashboardIndustria: false,

        custoFixo: false,
    };
}

export function usePessoaColaboradorModule({ pessoaId, pessoaColaborador, funcionario, setDadosPai }) {
    const [dados, setDados] = useState(createColaboradorDraft(pessoaId));

    useEffect(() => {
        const next = {
            ...createColaboradorDraft(pessoaId),
            ...(pessoaColaborador || {}),
            pessoaId: pessoaColaborador?.pessoaId || pessoaId || null,
            uuid: pessoaColaborador?.uuid || '',
            ativo: funcionario || pessoaColaborador?.ativo || false,
        };

        setDados(next);

        setDadosPai?.((prev) => ({
            ...prev,
            pessoaColaborador: next,
        }));
    }, [pessoaColaborador, pessoaId, funcionario, setDadosPai]);

    function change(e) {
        const { name, value, checked, type } = e.target;
        const field = name.split('.')[1];

        let newValue = value;

        if (type === 'checkbox') {
            newValue = checked;
        }

        if (field === 'comissao' || field === 'comissaoInterna' || field === 'comissaoExterna') {
            newValue = formatarNumeroDecimal(value);
        }

        setDados((prev) => {
            const next = {
                ...prev,
                [field]: newValue,
            };

            setDadosPai?.((prevPai) => ({
                ...prevPai,
                pessoaColaborador: next,
            }));

            return next;
        });
    }

    return {
        state: {
            dados,
        },
        actions: {
            change,
            setDados,
        },
    };
}
